module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "yoScroll",
    staticClass: "yo-scroll",
    class: {
      'down': (_vm.state === 0), 'up': (_vm.state == 1), refresh: (_vm.state === 2), touch: _vm.touching
    },
    style: ({
      top: _vm.divTop,
      marginBottom: _vm.divBottom
    }),
    on: {
      "touchstart": function($event) {
        _vm.touchStart($event)
      },
      "touchmove": function($event) {
        _vm.touchMove($event)
      },
      "touchend": function($event) {
        _vm.touchEnd($event)
      },
      "scroll": function($event) {
        (_vm.onInfinite || _vm.infiniteLoading) ? _vm.onScroll($event): undefined
      }
    }
  }, [_c('section', {
    staticClass: "inner",
    style: ({
      transform: 'translate3d(0, ' + _vm.top + 'px, 0)',
      top: _vm.top
    })
  }, [(_vm.enableRefresh) ? _c('header', {
    staticClass: "pull-refresh"
  }, [_vm._t("pull-refresh", [_c('span', {
    staticClass: "down-tip"
  }, [_vm._v("下拉更新")]), _vm._v(" "), _c('span', {
    staticClass: "up-tip"
  }, [_vm._v("松开更新")]), _vm._v(" "), _c('span', {
    staticClass: "refresh-tip"
  }, [_vm._v("更新中……")])])], 2) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('footer', {
    staticClass: "load-more"
  }, [_vm._t("load-more", [_c('span', [_vm._v(_vm._s(_vm.loadingText))])])], 2)], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollback),
      expression: "scrollback"
    }],
    staticClass: "BackTop",
    on: {
      "click": _vm.scrollbackClick
    }
  }, [_c('span', {
    staticClass: "icon iconfont icon-4fanhuidingbucheng",
    staticStyle: {
      "font-size": "25px"
    }
  }), _c('br'), _vm._v("返回顶部\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38781095","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pull-refresh.vue
// module id = DE6n
// module chunks = 7